module.exports = __webpack_public_path__ + "img/icon-puncher-cover.0d4b839c.png";